import { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { leerRuta, rutaDe } from '../rutas/rutasConsola';

/**
 * La ruta de la consola, leída de la URL, y la forma de cambiarla.
 *
 * `irA` y `navigate` conservan la identidad entre renders. El `navigate` de
 * react-router no: fuera de un data router cambia con cada `pathname`. El
 * Dashboard lo pasa a `useStompConnection`, cuyo efecto de montaje depende de
 * él, y con el original cada cambio de sección recrearía el cliente STOMP.
 */
export default function useRutaConsola() {
  const { pathname } = useLocation();
  const navigateDelRouter = useNavigate();
  const navigateRef = useRef(navigateDelRouter);
  const pathnameRef = useRef(pathname);

  useLayoutEffect(() => {
    navigateRef.current = navigateDelRouter;
    pathnameRef.current = pathname;
  });

  const navigate = useCallback((to, opciones) => navigateRef.current(to, opciones), []);

  // Con replace se sustituye la misma entrada, así que se le conserva la marca
  // de la trampa del atrás (ImpedirSalidaAlLogin). Se hace en el acto: un
  // efecto que la repusiera dejaría un hueco en el que el atrás saldría.
  const irA = useCallback((destino, { replace = false } = {}) => {
    const url = rutaDe(destino);
    if (url === pathnameRef.current) return;
    const eraTrampa = window.history.state?.salida === 'trampa';
    navigateRef.current(url, { replace });
    if (replace && eraTrampa) {
      window.history.replaceState({ ...window.history.state, salida: 'trampa' }, '');
    }
  }, []);

  const ruta = useMemo(() => leerRuta(pathname), [pathname]);

  return { ruta, irA, navigate };
}
